import React, { useCallback, useEffect, useState } from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";

import useSendEmailVerificationCode from "api/accounts/useSendEmailVerificationCode";

import EmailVerificationContent from "./EmailVerificationContent";

const EmailVerification = ({ email, isOpen, onClose, onSuccess }) => {
  const [nonce, setNonce] = useState(null);

  // send email verification hook
  const {
    mutateAsync: sendEmailVerificationCode,
    isSuccess: isSendEmailVerificationCodeSuccess,
    data: sendEmailVerificationCodeData,
  } = useSendEmailVerificationCode();

  // encapsulated function to send email verification code
  const callSendEmailVerificationCode = useCallback(() => {
    sendEmailVerificationCode({ email });
  }, [sendEmailVerificationCode, email]);

  // on mount, send email verification to the email passed through props
  useEffect(() => {
    if (isOpen) {
      callSendEmailVerificationCode();
    }
  }, [callSendEmailVerificationCode, isOpen]);

  // if initial email was sent successfully, store the nonce
  useEffect(() => {
    if (isSendEmailVerificationCodeSuccess) {
      if (sendEmailVerificationCodeData.codes.includes("verified_email_address")) {
        onSuccess();
        onClose();
      } else {
        setNonce(sendEmailVerificationCodeData.payload.nonce);
      }
    }
  }, [
    isSendEmailVerificationCodeSuccess,
    sendEmailVerificationCodeData,
    setNonce,
    onSuccess,
    onClose,
  ]);

  const handleSuccess = useCallback(() => {
    setNonce(null);
    onSuccess();
  }, [setNonce, onSuccess]);

  if (!nonce) {
    return null;
  }

  return (
    <Modal onClose={onClose} isOpen={isOpen} size="full">
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <EmailVerificationContent
            email={email}
            onClose={onClose}
            onSuccess={handleSuccess}
            initialNonce={nonce}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EmailVerification;
